import Route from "vue-routisan";
import vuex from "src/vuex";
import isGuest from "./middlewares/isGuest";

Route.group({prefix: "guest"},() =>{
  Route.view("/select_simulation", () =>
    import(/* webpackChunkName: "auth" */ "src/resources/views/guest/select_simulation/SelectRequestSimulation.vue")
  )
    .name("guest.select_request_simulation")
    .options({
      meta: {
        layout: () =>
          import(/* webpackChunkName: "guest" */ "src/resources/views/guest/Layout/EmptyLayout.vue")
      }
    });
  Route.view("/accept_quotation_transport", () =>
    import(/* webpackChunkName: "auth" */ "src/resources/views/guest/AcceptQuotationTransport/AcceptQuotationTransport.vue")
  )
    .name("guest.accept_quotation_transport")
    .options({
      meta: {
        layout: () =>
          import(/* webpackChunkName: "guest" */ "src/resources/views/guest/Layout/EmptyLayout.vue")
      }
    });
});


export default Route.all();
